import { useEffect, useState } from "react";
import { Table, Button, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { YhBox } from "@/components/YhBox";
import { ColumnsType, TablePaginationConfig } from "antd/es/table";
//import { IItemAndMaterialSearch, commonModuleService, IItemField, IMaterialField } from "./commonModuleService"
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISearchPage } from "@/types/ScmTypes";
import { transPgToPagination, momentFormat, repairFormatNum } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";
import { enquiryService } from "../enquiryService";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import YhTag from "@/components/YhTag";
import { useDictModel } from "@/views/base/dict/dictModel";

interface IRepairHistoryType {
    visible: boolean,
    code?: string,
    onCancel: () => void
}
export const DetailModel = ({
    visible,
    code = "",
    onCancel,
}: IRepairHistoryType) => {
    const { shopAndOrg } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const totalPgCfg = { pageSize: -1, pageNum: 1 }
    const [searchParam, setSearchParam] = useState<any>({})
    const [dataSource, setDataSource] = useState<any[]>([]);

    useEffect(() => {
        if (visible) {
            loadBillData(initPgCfg, { code })
            setSearchParam({ code })
        }
    }, [visible])
    const { getTreeNodeName, getTreeNodeOne } = useDictModel();

    const loadBillData = async (page?: ISearchPage, searchValue: any = searchParam) => {
        let searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await enquiryService.statisticsDetail(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    const statusColor: any = {
        "purchase_enquiry.init": "blue",
        "purchase_enquiry.end": "cyan",
        "purchase_enquiry.underway": "orange",
        "purchase_enquiry.audited": "green",
        "purchase_enquiry.reject": "red"
    }
    const columns: ColumnsType<any> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '询价单号',
            width: 120,
            dataIndex: 'code',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单据状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={getTreeNodeName(text)} />,
        }, {
            title: '供应商名称',
            width: 140,
            dataIndex: 'supplierName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '供应商评分',
            width: 120,
            dataIndex: 'totalScore',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '送货时间',
            width: 120,
            dataIndex: 'deliveryTime',
        }, {
            title: '控制价',
            width: 120,
            dataIndex: 'controlPrice',
        }, {
            title: '含税单价',
            width: 120,
            dataIndex: 'price',
        }, {
            title: '询价日期',
            width: 150,
            dataIndex: 'createTime',
        }, {
            title: '审批日期',
            width: 150,
            dataIndex: 'approvalTime',
        }, {
            title: '截止日期',
            width: 150,
            dataIndex: 'endTime',
        }
    ]

    return <YHModal
        visible={visible}
        onCancel={onCancel}
        title="询价明细"
        width={'70%'}
        bodyHeight={730}
        showFooter={false}
    >
        <YhBox title={""}>
            <Table
                bordered
                style={{ cursor: "pointer" }}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ["bottomCenter"],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadBillData({ pageNum, pageSize }).then();
                    }
                }}
                scroll={{ x: 'max-content', y: 650 }}
            />
        </YhBox>

    </YHModal>
}